import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/schedulerGroupDetails', request)
}

export {get}
